import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "col-12 mb-4" };
const _hoisted_2 = { class: "col-12 bg-white border rounded pt-4 pb-4 shadow-sm" };
const _hoisted_3 = { class: "selectedStoreInfos w-100" };
const _hoisted_4 = { class: "row no-gutters pointerhover" };
const _hoisted_5 = { class: "col-12 mb-1" };
const _hoisted_6 = { class: "h5-responsive" };
const _hoisted_7 = { class: "row no-gutters mt-3" };
const _hoisted_8 = { class: "row no-gutters mt-3" };
const _hoisted_9 = {
    key: 0,
    class: "strong fc-gray w-100 mb-2"
};
const _hoisted_10 = {
    key: 1,
    class: "font7-responsive mb-3"
};
const _hoisted_11 = { class: "w-100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const _component_opening_times_block = _resolveComponent("opening-times-block");
    const _component_google_maps_navigation_button = _resolveComponent("google-maps-navigation-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "h5-responsive" }, "Ausgewählter Store:", -1)),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString((_a = _ctx.currentShop) === null || _a === void 0 ? void 0 : _a.name), 1)
                    ])
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-100 font8-responsive fc-gray mb-3" }, [
                    _createElementVNode("img", {
                        src: "/images/store_pages/icon/icon_ankaufpartner.svg",
                        alt: "Ankaufpartner",
                        style: { "height": "16px", "width": "16px" }
                    }),
                    _createTextVNode(" Offizieller "),
                    _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                    _createTextVNode(" -Ankaufpartner ")
                ], -1)),
                _createElementVNode("div", null, _toDisplayString((_b = _ctx.currentShop) === null || _b === void 0 ? void 0 : _b.street_name), 1),
                _createElementVNode("div", null, _toDisplayString((_c = _ctx.currentShop) === null || _c === void 0 ? void 0 : _c.zip_code) + " " + _toDisplayString((_d = _ctx.currentShop) === null || _d === void 0 ? void 0 : _d.city), 1),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_opening_times_block, {
                        opening_times: (_f = (_e = _ctx.currentShop) === null || _e === void 0 ? void 0 : _e.opening_times) !== null && _f !== void 0 ? _f : null
                    }, null, 8, ["opening_times"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    ((_g = _ctx.currentShop) === null || _g === void 0 ? void 0 : _g.phone_contact)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Telefonnummer:"))
                        : _createCommentVNode("", true),
                    ((_h = _ctx.currentShop) === null || _h === void 0 ? void 0 : _h.phone_contact)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString((_j = _ctx.currentShop) === null || _j === void 0 ? void 0 : _j.phone_contact), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                        (_ctx.currentShop)
                            ? (_openBlock(), _createBlock(_component_google_maps_navigation_button, {
                                key: 0,
                                location: _ctx.currentShop,
                                class: "buttonBase buttonGreen"
                            }, null, 8, ["location"]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", null, [
            _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('resetShopWasClicked', _ctx.storeId))),
                class: "d-inline-block"
            }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                        src: "/images/_new_brand/icons/icon_store.svg",
                        alt: "zurück",
                        width: "20",
                        height: "22",
                        style: { "padding": "0 0 2px 0", "margin-right": "5px", "cursor": "pointer" }
                    }, null, -1),
                    _createElementVNode("span", { class: "link-in-text strong mt-4 d-inline-block" }, "Store ändern", -1)
                ]))])
        ])
    ]));
}
